import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import MaterialTable from 'material-table'
import AddIcon from '@mui/icons-material/Add'
import { Link } from 'react-router-dom'
import MyMaterialTable from '../../components/table'
import Api from "../../services/api"
import * as CalledService from '../../services/called.service'
import * as OrganizationCategoryService from '../../services/organizationcategory.service'
import * as OrganizationFieldService from '../../services/organizationfield.service'
import * as calledsActions from '../../redux/actions/calleds'
import * as TeamsService from '../../services/techinicalteam.service'
import { Can } from '../../config/ability-context'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer'
import moment from "moment"
import { FormattedMessage } from 'react-intl'
import SimpleCheckBox from "../../components/checkbox/check";
import { injectIntl } from 'react-intl'
import { getSlaAtendimento, getSlaSolucao } from '../called-list/called.functions'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import { saveAs } from 'file-saver'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple'
import SimpleAutoCompleteMultipleRequired from '../../components/auto-complete/autocomplete-multiple-required'

import SimpleAutoCompleteMultipleCategories from '../../components/auto-complete/autocomplete-multiple-create-categories'

import Pagination from '@mui/material/Pagination'
import Search from '@mui/icons-material/Search'
import TextField from '@mui/material/TextField'
import autoTable from 'jspdf-autotable'

import jsPDF from 'jspdf'
import 'jspdf-autotable'
import LogoMarca from '../../images/new-logo-cmtech.png'
import html2canvas from 'html2canvas'
import Divider from '@mui/material/Divider'
import * as ExcelJS from 'exceljs'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PapiroConsole } from "../../utils/papiroConsole"
import ApiReports from "../../services/apireport";
import ScheduleReportButton from "../../components/report-schedule";
import * as Service from '../../services/techinicalteamorganizationcategory.service';

class CalledsOriginCategoriesReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.typingTimeout = null
    this.organizationId = null

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    });

    if (userSession.user.organization)
      this.organizationId = userSession.user.organization.id

    this.state = {
      dateStart: moment().startOf('week').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().endOf('week').format('YYYY/MM/DD HH:mm:ss'),
      organizationId: this.organizationId,
      OrganizationFilter: 0,
      TechinicalTeamFilter: { id: 0, name: '' },
      location: 0,
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,
      calledsList: [],
      organizationList: [],
      TechinicalTeamList: [],
      organizationAddressesList: [],
      calledPdfList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: '',
      showHeader: false,
      strhtmlModalOpen: false,
      dialogHTMLString: '',
      OrgsList: [],
      CategoriesList: [],
      OriginList: [],
      customFieldId: "",
      OriginFilter: [],
      CategoryFilter:[],
      CustomFields : [],
      columns : [],
      columnsExcell : [],
      OrganizationCategories : [],
      groupId: 0,
      groupList: [],
      fullOrgList: [],
    }
    this.initialState = { ...this.state }
  }

  hasChanges() {
    const normalizeIds = values => (values || [])
      .map(value => String(value && value.id !== undefined && value.id !== null ? value.id : value))
      .sort();

    const getComparableState = state => ({
      dateStart: state.dateStart,
      dateEnd: state.dateEnd,
      organizationFilter: state.OrganizationFilter,
      techinicalTeamId: state.TechinicalTeamFilter && state.TechinicalTeamFilter.id ? state.TechinicalTeamFilter.id : 0,
      originIds: normalizeIds(state.OriginFilter),
      categoryIds: normalizeIds(state.CategoryFilter),
      groupId: state.groupId
    })

    return JSON.stringify(getComparableState(this.state)) !== JSON.stringify(getComparableState(this.initialState))
  }

  clear = async () => {
    clearTimeout(this.typingTimeout)

    await new Promise(resolve => {
      this.setState({
        ...this.initialState,
        OrgsList: this.state.fullOrgList,
        fullOrgList: this.state.fullOrgList,
        OriginList: this.state.OriginList,
        groupList: this.state.groupList,
        loading: true
      }, resolve)
    })

    try {
      await this.getTechinicalTeams()
    } finally {
      this.setState({ loading: false })
    }
  }

  openHTMLRenderModal = (htmlString) => {
    this.setState({ strhtmlModalOpen: !this.state.strhtmlModalOpen, dialogHTMLString: htmlString })
  }

  closeHTMLRenderModal = () => {
    this.setState({ strhtmlModalOpen: !this.state.strhtmlModalOpen, dialogHTMLString: '' })
  }



  changeValues = async (stateName, value, text = '') => {
    this.setState({ loading: true })

    if (stateName === 'groupId') {
      const selectedGroupId = value ? value.id : 0;
      const backupList = this.state.fullOrgList || [];

     
      const resetState = {
          OrganizationFilter: 0, 
          CategoryFilter: [],
          TechinicalTeamFilter: { id: 0, name: '' },
          TechinicalTeamList: []
      };

      if (selectedGroupId === 0) {
          this.setState({ 
              groupId: 0, 
              OrgsList: backupList,
              ...resetState, 
              loading: false 
          });
         
          this.getTechinicalTeams(); 
          return;
      }

      const filteredOrgs = backupList.filter(org => (org.groupId === selectedGroupId));

      this.setState({ 
          groupId: selectedGroupId, 
          OrgsList: filteredOrgs,
          ...resetState, 
          loading: false 
      });
      return;
  }

    if (stateName === 'OrganizationFilter') {

      this.setState({ [stateName]: value.id});
      if(value.id == 0){
        this.setState({ CategoryFilter: [], TechinicalTeamFilter: { id: 0, name: '' }, TechinicalTeamList: []});
        await this.getTechinicalTeams()
      }
      else{
        await this.getCategoriesByOrganization(value.id)
        await this.getTechinicalTeams(value.id)
        if (!this.state.TechinicalTeamList.find(t => t.id == this.state.TechinicalTeamFilter.id)) {
          this.setState({ TechinicalTeamFilter: { id: 0, name: '' } })
        }
      }
    }

    else if (stateName == 'selectCategories') {
      if (value == true) {

        this.setState({ CategoryFilter: this.state.OrganizationCategories});
        
      } else {
        this.setState({ CategoryFilter: []});
      
      }
    }

    
    
    else{
      PapiroConsole.log(value)
      PapiroConsole.log("value")
      this.setState({ [stateName]: value });
    }




    


    this.setState({ loading: false })
  };

  Reload = () => {
    const reload = localStorage.getItem('reload')
    if (reload == "true")
      localStorage.setItem('reload', false)
    return null;
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getCalleds('', page)
  }

  exportPdf = _ => {
    this.getCalledsToPdf()
  }

  async getCategoriesByOrganization(organizationId) {
    this.setState({ loading: true });
    PapiroConsole.log("entrei aqui na função")
    const result = await OrganizationCategoryService.getbyorganization(organizationId);

    if (result.success) {
          PapiroConsole.log(result)
          PapiroConsole.log("result custom aqui")

        this.setState({ loading: false, OrganizationCategories: result.data });
    } else {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(result);

    }
};

  

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }

  async getTechinicalTeams(OrganizationId = 0) {
    var result = null
    if (OrganizationId > 0) {
      result = await Service.getTechinicalTeamsByOrganization(OrganizationId);
    } else {
      result = await Service.getTechinicalTeams()
    }
    if (result.success) {
      this.setState({ TechinicalTeamList: result.data });

    } else {
      const intl = this.props.intl;
      this.setState({
        openNotification: true, notificationVariant: 'error',
        notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  onFieldChange = event => {
    // Clears the previously set timer.
    clearTimeout(this.typingTimeout)
    // Reset the timer, to make the http call after 475MS (this.callSearch is a method which will call the search API. Don't forget to bind it in constructor.)
    this.typingTimeout = setTimeout(this.callSearch, 475);
    this.setState({ [event.target.name]: event.target.value, page: 1 })
  }

  callSearch = _ => {
    this.getCalleds('', this.state.page)
  }

   getGroups = async () => {
  try {
      const result = await Api.get('/groups');
      if (result.data) {
            this.setState({ groupList: result.data.data || result.data });
      }
  } catch (err) {
      console.log("Erro ao buscar grupos", err);
  }
}

 getOrganizations = async _ => {
    try {
     
      const result = await Api.get('/organizations/tech');
      
      let data = [];
      if (result.data && result.data.data) {
           data = result.data.data;
      } else if (result.data && Array.isArray(result.data)) {
           data = result.data;
      }

    
      const dataNormalizada = data.map(item => {
          const orgReal = item.organization || item; 
          return {
              ...orgReal, 
             
              groupId: orgReal.groupId || orgReal.groupid || orgReal.GroupId || (orgReal.Group ? orgReal.Group.Id : null)
          };
      });

      this.setState({ 
          OrgsList: dataNormalizada,    
          fullOrgList: dataNormalizada,   
          loading: false
      })
    } catch (err) {
      console.log("Erro ao buscar organizações:", err);
      this.setState({ OrgsList: [], loading: false });
    }
  }

  getOrigins = async _ => {
    let data = [];
     
      await Api.get('/originrequests/selectionmodel')
        .then(result => {
          data = result.data.data
        })
        .catch(err => {
          data = err
        });
    
    this.setState({ OriginList: data })
  }

  deleteItem = (data, resolve) => {
    const intl = this.props.intl;
    let abl = this.context.can('Delete', 'Called')
    if (!abl) {
      this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: this.props.intl.formatMessage({ id: "operation.notAllowed" }) })
      resolve()
      return false
    }
    Api.delete(`/logmail/${data.id}`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: intl.formatMessage({ id: "called.list.notification.delete.success" }),
            resultList: []
          })

          this.getCalleds()
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
        resolve()
      })
      .catch(err => {
        resolve()
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  }

  async componentDidMount() {
    this.setState({ loading: true })

    await this.getGroups();
    await this.getOrganizations()
    await this.getOrigins()
    await this.getTechinicalTeams()

    this.setState({ loading: false })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "techinicalteamsreport")
      this.getCalleds(this.props.location.state)
    else if (nextProps.location.state === "assignedcalleds")
      this.getCalleds(nextProps.location.state)
    else if (nextProps.location.state === "reload")
      this.componentDidMount()
  }

  getFile = async () => {

   /* const intl = this.props.intl;
    this.setState({ loading: true })

    let originList = this.state.OriginFilter;
    var originids = "";
    if (originList != null && originList != "") {
      for (let value in originList) {
        originids = originList[value].id + "," + originids;
        
      }
      if(originids.length > 0){ 
        originids = originids.substr(0, originids.length - 1);
      }

    }
    let Categorylist = this.state.CategoryFilter;
    var categoriesids = "";
    if (Categorylist != null && Categorylist != "") {
      for (let value in Categorylist) {
        categoriesids = Categorylist[value].id + "," + categoriesids;
        
      }
      if(categoriesids.length > 0){ 
        categoriesids = categoriesids.substr(0, categoriesids.length - 1);
      }

    }

    



    let url = `/calleds/getexcell/calledsorigincategories?org=${this.state.OrganizationFilter}&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&originids=${originids}&categoriesids=${categoriesids}`
    var total = 0
    Api.get(url)
      .then(async (result) => {
        PapiroConsole.log(result)
        PapiroConsole.log("result")
        const formattedList = result.data.data.map(item => {
          if(item.count){
              total += item.count
          }
          return {
            ...item,
          }

        })

        PapiroConsole.log(formattedList)
        PapiroConsole.log("formattedList")
        

        const intl = this.props.intl
        const wb = new ExcelJS.Workbook()

        const ws = wb.addWorksheet()

        await this.getColumnsExcell(formattedList)
        var endRow = formattedList.length
        
   
  
        ws.columns = this.state.columnsExcell

        ws.getCell('A1').style = { font: { bold: true } }
        ws.getCell('B1').style = { font: { bold: true } }
        ws.getCell('C1').style = { font: { bold: true } }
        ws.getCell('D1').style = { font: { bold: true } }
        ws.getCell('E1').style = { font: { bold: true } }
        ws.getCell('F1').style = { font: { bold: true } }
        ws.getCell('G1').style = { font: { bold: true } }
        
        //var count = (this.state.columnsExcell.length - 14);
        //ws.getCell(`G${2}`).value = { formula: `SUM(F2:F${endRow})`, date1904: false };
        
        let g2 = ws.getCell('G2');
        g2.value = total
        ws.addRows(formattedList);
        ws.addRow([]);
        const newRowValues = [intl.formatMessage({ id: "export.date" }), moment().format('DD/MM/YYYY HH:mm:ss') ];
        const newRow = ws.addRow(newRowValues);


       
        const buf = await wb.xlsx.writeBuffer()

        saveAs(new Blob([buf]), 'relatorio_chamadosorigemcategorias.xlsx')
        this.setState({ loading: false })
      })
      .catch(err => {
        
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })*/
      this.setState({ loading: true })
      let originList = this.state.OriginFilter;
    var originids = "";
    if (originList != null && originList != "") {
      for (let value in originList) {
        originids = originList[value].id + "," + originids;
        
      }
      if(originids.length > 0){ 
        originids = originids.substr(0, originids.length - 1);
      }

    }
    let Categorylist = this.state.CategoryFilter;
    var categoriesids = "";
    if (Categorylist != null && Categorylist != "") {
      for (let value in Categorylist) {
        categoriesids = Categorylist[value].id + "," + categoriesids;
        
      }
      if(categoriesids.length > 0){ 
        categoriesids = categoriesids.substr(0, categoriesids.length - 1);
      }

    }


      let url = `/report/calledsorigincategories/excell/new?org=${this.state.OrganizationFilter}&techteam=${this.state.TechinicalTeamFilter.id}&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&originids=${originids}&categoriesids=${categoriesids}&groupId=${this.state.groupId}`

      ApiReports.get(url)
        .then((response) => {
            if (response.data.success) {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'success',
                    notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
                });
            } else {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
            }
        })
        .catch((error) => {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: error.response && error.response.data && error.response.data.errors && error.response.data.errors[0] ? error.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            });
        });
  }

  getMessageBadUseFlag = message => {
    const intl = this.props.intl;
    let writing = ""
    if (message === true)
      writing = intl.formatMessage({ id: "yes" })
    else if (message === false)
      writing = intl.formatMessage({ id: "no" })
    else
      writing = intl.formatMessage({ id: "undefined" })

    return writing
  }

  getColumns(data){

 
    const intl = this.props.intl;
    var columns = 
    [

      
      { title: intl.formatMessage({ id: "day" }), field: 'dia' },
      { title: intl.formatMessage({ id: "month" }), field: 'mes' },
      { title: intl.formatMessage({ id: "year" }), field: 'ano' },
      { title: intl.formatMessage({ id: "origin.request" }), field: 'origem' },
      { title: intl.formatMessage({ id: "category" }), field: 'categoria' },
      { title: intl.formatMessage({ id: "total" }), field: 'count' },
     

    ];

    this.setState({ columns: columns })
    
  }


  async getColumnsExcell(data){

  
    const intl = this.props.intl;

    var columns = [

      
      { header: intl.formatMessage({ id: "day" }), key: 'dia',width: 25 },
      { header: intl.formatMessage({ id: "month" }), key: 'mes',width: 25 },
      { header: intl.formatMessage({ id: "year" }), key: 'ano',width: 25 },
      { header: intl.formatMessage({ id: "origin.request" }), key: 'origem',width: 25 },
      { header: intl.formatMessage({ id: "category" }), key: 'categoria',width: 25 },
      { header: intl.formatMessage({ id: "total" }), key: 'count',width: 25 },
      { header: intl.formatMessage({ id: "called.mounth" }),width: 25 },
      
      
  ];


    
    await this.setState({ columnsExcell: columns })
    
  }




  getCalleds = async (filter = '', page = 1) => {

    const intl = this.props.intl;

    this.setState({ loading: true });

    
    let list = this.state.OriginFilter;
    var originids = "";
    if (list != null && list != "") {
      for (let value in list) {
        originids = list[value].id + "," + originids;
        
      }
      if(originids.length > 0){ 
        originids = originids.substr(0, originids.length - 1);
      }

    }
    let Categorylist = this.state.CategoryFilter;
    var categoriesids = "";
    if (Categorylist != null && Categorylist != "") {
      for (let value in Categorylist) {
        categoriesids = Categorylist[value].id + "," + categoriesids;
        
      }
      if(categoriesids.length > 0){ 
        categoriesids = categoriesids.substr(0, categoriesids.length - 1);
      }

    }
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (dateStart > dateEnd) {
      const { intl } = this.props
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });
    }
    else {
      let url = `/report/calledsorigincategories/paginate?page=${page}&org=${this.state.OrganizationFilter}&techteam=${this.state.TechinicalTeamFilter.id}&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&originids=${originids}&categoriesids=${categoriesids}&groupId=${this.state.groupId}`



      this.setState({ showGrid: true, scheduleRequest: url })

      var writing = ""

      ApiReports.get(url)
        .then(result => {
          if (result.data.success) {
            PapiroConsole.log("result aqui formatted")
            PapiroConsole.log(result.data)
            let count = result.data.count
            this.setState({ count: count })
            this.setPagination(count, page)

            const formattedList = result.data.data.map(item => {
              return {
                ...item,
               
              }
            })

            

            this.setState({ calledsList: formattedList, loading: false })

            this.getColumns(formattedList)
          
          } else {
            this.setState({
              loading: false, openNotification: true, notificationVariant: 'error',
              notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
          }
        })
        .catch(err => {
          
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(err)
        })

    }


  }

  getMessageExcellBadUseFlag = (message, status) => {
    const intl = this.props.intl;
    let writing = ""
    if (status === intl.formatMessage({ id: "finished" })) {
      if (message === true)
        writing = intl.formatMessage({ id: "yes" })
      else if (message === false)
        writing = intl.formatMessage({ id: "no" })
    } else
      writing = intl.formatMessage({ id: "undefined" })

    return writing
  }


  getCalledsToPdf = (filter = '') => {
    const intl = this.props.intl;
    this.setState({ loading: true })
    
    let list = this.state.OriginFilter;
    var originids = "";
    if (list != null && list != "") {
      for (let value in list) {
        originids = list[value].id + "," + originids;
        
      }
      if(originids.length > 0){ 
        originids = originids.substr(0, originids.length - 1);
      }

    }
    let Categorylist = this.state.CategoryFilter;
    var categoriesids = "";
    if (Categorylist != null && Categorylist != "") {
      for (let value in Categorylist) {
        categoriesids = Categorylist[value].id + "," + originids;
        
      }
      if(categoriesids.length > 0){ 
        categoriesids = categoriesids.substr(0, categoriesids.length - 1);
      }

    }



    let url = `/techinicalteams/getexcell?org=${this.state.OrganizationFilter}}&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&originids=${originids}&categoriesids=${categoriesids}`

    Api.get(url)
      .then(async (result) => {
        if (result.data.success) {
          PapiroConsole.log(result)
          PapiroConsole.log("result")
          await this.setState({ showHeader: true })
          const formattedList = result.data.data.map(item => {

            return {
              ...item,
              Name: item.name,
              TotalUsers: item.total_users,
              Organizacoes: item.organizacoes,
            }
          })

          const intl = this.props.intl
          const doc = new jsPDF("p", "mm", "a4")
          const header = document.getElementById('header-pdf')
          let headerCanvas = await html2canvas(header)
          const headerImg = headerCanvas.toDataURL('image/png')
          doc.addImage(headerImg, 'PNG', 0, 0)

          doc.autoTable({
            body: formattedList,
            margin: { top: 30 },
            bodyStyles: { valign: 'middle' },
            styles: { overflow: 'linebreak', columnWidth: 'wrap', fontSize: 7, halign: 'center' },
            theme: 'striped',
            columns: [
              { header: intl.formatMessage({ id: "name" }), dataKey: 'Name' },
              { header: intl.formatMessage({ id: "total.users" }), dataKey: 'TotalUsers' },
              { header: intl.formatMessage({ id: "menu.organizations" }), dataKey: 'Organizacoes' },


            ],
            columnStyles: {
              Name: {
                columnWidth: 30
              },
              TotalUsers: {
                columnWidth: 30
              },
              Organizacoes: {
                columnWidth: 30
              },

            }
          })

          doc.save("relatorio-times-enviados.pdf")
          this.setState({ loading: false, showHeader: false })
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })
  }

  handleSubmit = async e => {
    const intl = this.props.intl;
    e.preventDefault();
    this.setState({ loading: true });
    await this.getCalleds(this.props.location.state)



  }

 
  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    
    

    
    

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      return (
        <>

          <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
            <Accordion >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container style={{ marginBottom: 20 }} spacing={2}>



                  <Grid item xs={12} sm={6} md={3}  >
                    <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} >
                    <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} >
                    <SimpleAutoCompleteMultipleRequired label={intl.formatMessage({ id: "origin.request" })} options={this.state.OriginList} stateName='OriginFilter' changeSelect={this.changeValues} selected={this.state.OriginFilter}/>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                      <SimpleAutoComplete label="Grupo" options={this.state.groupList} stateName='groupId' selected={this.state.groupList.find(x => x.id === this.state.groupId) || null} changeSelect={this.changeValues} getOptionLabel={(option) => option.Name || option.name || ""}/>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} >
                    <SimpleAutoComplete key={this.state.groupId}  label={intl.formatMessage({ id: "organization" })} options={this.state.OrgsList} stateName='OrganizationFilter' selected={this.state.OrgsList.find(x => x.id === this.state.OrganizationFilter) || null} changeSelect={this.changeValues} required/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoComplete label={intl.formatMessage({ id: "productivity.dashboard.techinical.teams" })} options={this.state.TechinicalTeamList} stateName='TechinicalTeamFilter' selected={this.state.TechinicalTeamFilter} changeSelect={this.changeValues} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={5} >
                  <SimpleAutoCompleteMultipleCategories label={intl.formatMessage({ id: "menu.categories" })} options={this.state.OrganizationCategories} stateName='CategoryFilter' changeSelect={this.changeValues} selected={this.state.CategoryFilter} />
                  </Grid>
                  <Grid item xs={2} sm={2} >
                    <SimpleCheckBox label={intl.formatMessage({id:"select.all.categories"})} name='selectCategories' stateName='selectCategories' changeSelect={this.changeValues} selected={this.state.selectCategories} />
                  </Grid>


                </Grid>
              </AccordionDetails>
            </Accordion>


            <Grid container style={{ marginBottom: 10 }}>
              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='secondary' >
                  {<FormattedMessage id="filter" />}
                </Button>
              </Grid>

              {this.state.showGrid && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  fullWidth
                  variant='contained'
                  color='secondary'
                  onClick={this.getFile} >
                  {<FormattedMessage id="export.plan" />}
                </Button>
              </Grid>}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="calleds-origin-categories" request={this.state.scheduleRequest} color="secondary" />
</Grid>}

              {5 == 2 && this.state.showGrid && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  fullWidth
                  variant='contained'
                  color='secondary'
                  onClick={this.getCalledsToPdf} >
                  {<FormattedMessage id="dash.pdf" />}
                </Button>
              </Grid>}

              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  type='button'
                  fullWidth
                  variant='contained'
                  color='secondary'
                  disabled={this.state.loading || !this.hasChanges()}
                  onClick={this.clear} >
                  {<FormattedMessage id="clear" />}
                </Button>
              </Grid>
            </Grid>
          </form>

          {
            this.state.showGrid && <>
              <MyMaterialTable
                title=""
                columns={
                  this.state.columns
                  }
                data={this.state.calledsList} />

              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </>
          }
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft:0, marginLeft:0}}>
            <CssBaseline />
            {this.state.showHeader &&
              <Grid container>
                <Grid id="header-pdf" item lg={4} sm={12} xl={this.state.grid} xs={12} style={{ padding: '2px' }}>
                  <Card >
                    <CardContent>
                      <img src={LogoMarca} style={{ width: "70px" }} /> <span style={{ marginLeft: 25, fontSize: 18 }}> {<FormattedMessage id="calleds.origin.categories.report" />}</span>
                      <Divider />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            }

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      {<FormattedMessage id="calleds.origin.categories.report" />}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>


            {tableList()}


            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

CalledsOriginCategoriesReport.propTypes = {
  classes: PropTypes.object.isRequired
}


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CalledsOriginCategoriesReport)))
CalledsOriginCategoriesReport.contextType = AbilityContext